// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flat-list-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
}

/* Header Styles */
.flat-list-header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.flatlistheader-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg,  #d85200 0%,  #d85200 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.8rem;
  box-shadow: 0 4px 15px  #d8530013;
}

.header-text h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 8px 0;
  background: linear-gradient(135deg,  #d85200 0%,  #d85200 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.header-text p {
  color: #718096;
  font-size: 1.1rem;
  margin: 0;
  font-weight: 400;
}

.add-flat-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px 25px;
  background: linear-gradient(135deg,  #d85200 0%,  #d85200 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px  #d8530013;
}

.add-flat-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(216, 83, 0, 0.133);
}

/* Statistics */
.stats-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  padding: 25px;
  display: flex;
  align-items: center;
  gap: 15px;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(5px);
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.stat-card.total {
  border-left: 4px solid #4299e1;
}

.stat-card.available {
  border-left: 4px solid #48bb78;
}

.stat-card.booked {
  border-left: 4px solid #f56565;
}

.stat-icon {
  font-size: 2rem;
  opacity: 0.8;
}

.stat-card.total .stat-icon {
  color: #4299e1;
}

.stat-card.available .stat-icon {
  color: #48bb78;
}

.stat-card.booked .stat-icon {
  color: #f56565;
}

.stat-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stat-number {
  font-size: 2rem;
  font-weight: 700;
  color: #2d3748;
  line-height: 1;
}

.stat-label {
  font-size: 0.9rem;
  color: #718096;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Filter Section */
.filter-section {
  display: flex;
  gap: 20px;
  align-items: center;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.8);
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.filter-icon {
  color:  #d85200;
  font-size: 1.1rem;
}

.filter-select {
  border: none;
  background: transparent;
  font-size: 0.9rem;
  font-weight: 500;
  color: #2d3748;
  cursor: pointer;
  outline: none;
}

/* Floors Container */
.floors-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.floor-section {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 25px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.floor-section:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.floor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e2e8f0;
}

.floor-title {
  display: flex;
  align-items: center;
  gap: 15px;
}

.floor-icon {
    font-size: 1.5rem;
    color: #d85200;
}
.floor-title h2 {
  font-size: 1.8rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
}

.floor-badge {
  background: linear-gradient(135deg,  #d85200 0%,  #d85200 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.floor-stats {
  display: flex;
  gap: 20px;
  align-items: center;
}

.floor-stat {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #4a5568;
}

.stat-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.stat-dot.available {
  background: #48bb78;
  box-shadow: 0 0 10px rgba(72, 187, 120, 0.5);
}

.stat-dot.booked {
  background: #f56565;
  box-shadow: 0 0 10px rgba(245, 101, 101, 0.5);
}

/* Flats Grid */
.flats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.flat-card {
  position: relative;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  padding: 20px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
  backdrop-filter: blur(5px);
  overflow: hidden;
}

.flat-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, transparent, #d85200, transparent);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.flat-card:hover::before {
  transform: translateX(100%);
}

.flat-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  border-color:  #d853000b;
}

.flat-status-indicator {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  color: white;
  z-index: 2;
}

.flat-status-indicator.available {
  background: linear-gradient(135deg, #48bb78, #38a169);
  box-shadow: 0 4px 15px rgba(72, 187, 120, 0.3);
}

.flat-status-indicator.booked {
  background: linear-gradient(135deg, #f56565, #e53e3e);
  box-shadow: 0 4px 15px rgba(245, 101, 101, 0.3);
}

.flat-button {
  width: 100%;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  border-radius: 12px;
  transition: all 0.3s ease;
  margin-bottom: 15px;
}

.flat-button:hover {
  transform: scale(1.02);
}

.flat-content {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
}

.flat-button.available .flat-content {
  border-left: 4px solid #48bb78;
}

.flat-button.booked .flat-content {
  border-left: 4px solid #f56565;
}

.flat-button:hover .flat-content {
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.flat-icon {
  font-size: 1.5rem;
  color: #667eea;
  opacity: 0.8;
}

.flat-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 1;
}

.flat-identifier {
  font-size: 1.2rem;
  font-weight: 700;
  color: #2d3748;
}

.flat-type {
  font-size: 0.85rem;
  font-weight: 500;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.flat-price {
  font-size: 1rem;
  font-weight: 600;
  color: #48bb78;
}

.delete-button {
  position: absolute;
  bottom: 15px;
  right: 15px;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background: linear-gradient(135deg, #f56565, #e53e3e);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(245, 101, 101, 0.3);
  opacity: 0;
  transform: scale(0.8);
}

.flat-card:hover .delete-button {
  opacity: 1;
  transform: scale(1);
}

.delete-button:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(245, 101, 101, 0.4);
  background: linear-gradient(135deg, #e53e3e, #c53030);
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  backdrop-filter: blur(5px);
}

.flat-detail-modal,
.add-flat-modal {
  background: white;
  border-radius: 20px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;
  scrollbar-width: none;
}

.customer-modal {
  background: white;
  border-radius: 20px;
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 30px;
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 20px 20px 0 0;
}

.modal-header h3 {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
}

.modal-icon {
  color: #667eea;
}

.close-button {
  width: 40px;
  height: 40px;
  border: none;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.2rem;
  color: #718096;
}

.close-button:hover {
  background: rgba(245, 101, 101, 0.1);
  color: #f56565;
  transform: scale(1.1);
}

.modal-content {
  padding: 30px;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  background: #f8fafc;
  border-radius: 12px;
  border-left: 4px solid  #d85200;
}

.detail-icon {
  font-size: 1.2rem;
  color:  #d85200;
}

.detail-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-label {
  font-size: 0.8rem;
  color: #718096;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-value {
  font-size: 1rem;
  font-weight: 600;
  color: #2d3748;
}

.detail-value.status.available {
  color: #48bb78;
}

.detail-value.status.booked {
  color: #f56565;
}

.detail-value.price {
  color: #48bb78;
  font-size: 1.1rem;
}

.modal-footer {
  padding: 20px 30px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}

.view-customer-btn,
.add-customer-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.view-customer-btn {
  background: linear-gradient(135deg,  #d85200, #d85200);
  color: white;
}

.add-customer-btn {
  background: linear-gradient(135deg, #48bb78, #38a169);
  color: white;
}

.view-customer-btn:hover,
.add-customer-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* Form Styles */
.add-flat-form,
.customer-form {
  padding: 30px;
}

.form-section {
  margin-bottom: 30px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.2rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e2e8f0;
}

.section-icon {
  color: #667eea;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: #4a5568;
  font-size: 0.9rem;
}

.form-input,
.form-select,
.form-textarea {
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background: white;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-input.readonly {
  background: #f8fafc;
  color: #718096;
  cursor: not-allowed;
}

.form-textarea {
  resize: vertical;
  min-height: 80px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
  margin-top: 30px;
}

.cancel-btn {
  padding: 12px 24px;
  border: 2px solid #e2e8f0;
  background: white;
  color: #718096;
  border-radius: 10px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  border-color: #cbd5e0;
  color: #4a5568;
}

.submit-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(135deg,  #d85200 0%,  #d85200 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px  #d8530014;
}

/* Responsive Design */
@media (max-width: 768px) {
  .flat-list-container {
    padding: 15px;
  }

  .flat-list-header {
    padding: 20px;
  }

  .header-content {
    /* flex-direction: column; */
    gap: 20px;
    align-items: stretch;
  }

  .header-text h1 {
    font-size: 2rem;
    text-align: center;
  }

  .stats-container {
    grid-template-columns: 1fr;
  }

  .floor-header {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }

  .floor-stats {
    align-self: stretch;
    justify-content: space-around;
  }

  .flats-grid {
    grid-template-columns: 1fr;
  }

  .detail-grid {
    grid-template-columns: 1fr;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .modal-overlay {
    padding: 10px;
  }

  .customer-modal {
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .flat-list-header {
    padding: 15px;
  }

  .header-text h1 {
    font-size: 1.8rem;
  }

  .stat-card {
    padding: 20px;
  }

  .floor-section {
    padding: 15px;
  }

  .flat-card {
    padding: 15px;
  }

  .modal-header {
    padding: 20px;
  }

  .modal-content,
  .add-flat-form,
  .customer-form {
    padding: 20px;
  }

  .form-actions {
    flex-direction: column;
  }

  .cancel-btn,
  .submit-btn {
    width: 100%;
    justify-content: center;
  }
}

/* Loading and Animation States */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.floor-section {
  animation: slideInUp 0.6s ease-out;
}

.flat-card {
  animation: slideInUp 0.6s ease-out;
  animation-delay: calc(var(--index, 0) * 0.1s);
}

/* Accessibility Improvements */
.flat-button:focus,
.delete-button:focus,
.add-flat-btn:focus {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}

.delete-button:focus {
  opacity: 1;
  transform: scale(1);
}

/* Print Styles */
@media print {
  .flat-list-container {
    background: white;
    padding: 0;
  }

  .delete-button,
  .add-flat-btn {
    display: none;
  }

  .flat-card {
    page-break-inside: avoid;
    break-inside: avoid;
    box-shadow: none;
    border: 1px solid #e2e8f0;
  }

  .modal-overlay {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/addflat/Flatlist.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,mEAAmE;AACrE;;AAEA,kBAAkB;AAClB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+DAA+D;EAC/D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,+DAA+D;EAC/D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+DAA+D;EAC/D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,+DAA+D;EAC/D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,iDAAiD;EACjD,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qEAAqE;EACrE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,2CAA2C;EAC3C,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,+CAA+C;EAC/C,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,qDAAqD;AACvD;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sDAAsD;EACtD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;;EAEE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;;EAEE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,+DAA+D;EAC/D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;IAC5B,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA,+BAA+B;AAC/B;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,wBAAmB;IAAnB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".flat-list-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  padding: 20px;\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* Header Styles */\n.flat-list-header {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 30px;\n  margin-bottom: 30px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.flatlistheader-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.header-icon {\n  width: 60px;\n  height: 60px;\n  background: linear-gradient(135deg,  #d85200 0%,  #d85200 100%);\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 1.8rem;\n  box-shadow: 0 4px 15px  #d8530013;\n}\n\n.header-text h1 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0 0 8px 0;\n  background: linear-gradient(135deg,  #d85200 0%,  #d85200 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.header-text p {\n  color: #718096;\n  font-size: 1.1rem;\n  margin: 0;\n  font-weight: 400;\n}\n\n.add-flat-btn {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 15px 25px;\n  background: linear-gradient(135deg,  #d85200 0%,  #d85200 100%);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px  #d8530013;\n}\n\n.add-flat-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(216, 83, 0, 0.133);\n}\n\n/* Statistics */\n.stats-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.stat-card {\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 16px;\n  padding: 25px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  transition: all 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  backdrop-filter: blur(5px);\n}\n\n.stat-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n}\n\n.stat-card.total {\n  border-left: 4px solid #4299e1;\n}\n\n.stat-card.available {\n  border-left: 4px solid #48bb78;\n}\n\n.stat-card.booked {\n  border-left: 4px solid #f56565;\n}\n\n.stat-icon {\n  font-size: 2rem;\n  opacity: 0.8;\n}\n\n.stat-card.total .stat-icon {\n  color: #4299e1;\n}\n\n.stat-card.available .stat-icon {\n  color: #48bb78;\n}\n\n.stat-card.booked .stat-icon {\n  color: #f56565;\n}\n\n.stat-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.stat-number {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #2d3748;\n  line-height: 1;\n}\n\n.stat-label {\n  font-size: 0.9rem;\n  color: #718096;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Filter Section */\n.filter-section {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: rgba(255, 255, 255, 0.8);\n  padding: 12px 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.filter-icon {\n  color:  #d85200;\n  font-size: 1.1rem;\n}\n\n.filter-select {\n  border: none;\n  background: transparent;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #2d3748;\n  cursor: pointer;\n  outline: none;\n}\n\n/* Floors Container */\n.floors-container {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.floor-section {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 25px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n}\n\n.floor-section:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\n}\n\n.floor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 25px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.floor-title {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.floor-icon {\n    font-size: 1.5rem;\n    color: #d85200;\n}\n.floor-title h2 {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 0;\n}\n\n.floor-badge {\n  background: linear-gradient(135deg,  #d85200 0%,  #d85200 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.floor-stats {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n\n.floor-stat {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #4a5568;\n}\n\n.stat-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.stat-dot.available {\n  background: #48bb78;\n  box-shadow: 0 0 10px rgba(72, 187, 120, 0.5);\n}\n\n.stat-dot.booked {\n  background: #f56565;\n  box-shadow: 0 0 10px rgba(245, 101, 101, 0.5);\n}\n\n/* Flats Grid */\n.flats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n.flat-card {\n  position: relative;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 16px;\n  padding: 20px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 2px solid transparent;\n  backdrop-filter: blur(5px);\n  overflow: hidden;\n}\n\n.flat-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, transparent, #d85200, transparent);\n  transform: translateX(-100%);\n  transition: transform 0.6s ease;\n}\n\n.flat-card:hover::before {\n  transform: translateX(100%);\n}\n\n.flat-card:hover {\n  transform: translateY(-8px) scale(1.02);\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);\n  border-color:  #d853000b;\n}\n\n.flat-status-indicator {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.9rem;\n  color: white;\n  z-index: 2;\n}\n\n.flat-status-indicator.available {\n  background: linear-gradient(135deg, #48bb78, #38a169);\n  box-shadow: 0 4px 15px rgba(72, 187, 120, 0.3);\n}\n\n.flat-status-indicator.booked {\n  background: linear-gradient(135deg, #f56565, #e53e3e);\n  box-shadow: 0 4px 15px rgba(245, 101, 101, 0.3);\n}\n\n.flat-button {\n  width: 100%;\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  border-radius: 12px;\n  transition: all 0.3s ease;\n  margin-bottom: 15px;\n}\n\n.flat-button:hover {\n  transform: scale(1.02);\n}\n\n.flat-content {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 15px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.5);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  transition: all 0.3s ease;\n}\n\n.flat-button.available .flat-content {\n  border-left: 4px solid #48bb78;\n}\n\n.flat-button.booked .flat-content {\n  border-left: 4px solid #f56565;\n}\n\n.flat-button:hover .flat-content {\n  background: rgba(255, 255, 255, 0.8);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.flat-icon {\n  font-size: 1.5rem;\n  color: #667eea;\n  opacity: 0.8;\n}\n\n.flat-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  flex: 1;\n}\n\n.flat-identifier {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #2d3748;\n}\n\n.flat-type {\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: #718096;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.flat-price {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #48bb78;\n}\n\n.delete-button {\n  position: absolute;\n  bottom: 15px;\n  right: 15px;\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #f56565, #e53e3e);\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(245, 101, 101, 0.3);\n  opacity: 0;\n  transform: scale(0.8);\n}\n\n.flat-card:hover .delete-button {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.delete-button:hover {\n  transform: scale(1.1);\n  box-shadow: 0 6px 20px rgba(245, 101, 101, 0.4);\n  background: linear-gradient(135deg, #e53e3e, #c53030);\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  backdrop-filter: blur(5px);\n}\n\n.flat-detail-modal,\n.add-flat-modal {\n  background: white;\n  border-radius: 20px;\n  max-width: 600px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: modalSlideIn 0.3s ease-out;\n  scrollbar-width: none;\n}\n\n.customer-modal {\n  background: white;\n  border-radius: 20px;\n  max-width: 900px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-50px) scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 25px 30px;\n  border-bottom: 1px solid #e2e8f0;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-radius: 20px 20px 0 0;\n}\n\n.modal-header h3 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 0;\n}\n\n.modal-icon {\n  color: #667eea;\n}\n\n.close-button {\n  width: 40px;\n  height: 40px;\n  border: none;\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1.2rem;\n  color: #718096;\n}\n\n.close-button:hover {\n  background: rgba(245, 101, 101, 0.1);\n  color: #f56565;\n  transform: scale(1.1);\n}\n\n.modal-content {\n  padding: 30px;\n}\n\n.detail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.detail-item {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 15px;\n  background: #f8fafc;\n  border-radius: 12px;\n  border-left: 4px solid  #d85200;\n}\n\n.detail-icon {\n  font-size: 1.2rem;\n  color:  #d85200;\n}\n\n.detail-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.detail-label {\n  font-size: 0.8rem;\n  color: #718096;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.detail-value {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.detail-value.status.available {\n  color: #48bb78;\n}\n\n.detail-value.status.booked {\n  color: #f56565;\n}\n\n.detail-value.price {\n  color: #48bb78;\n  font-size: 1.1rem;\n}\n\n.modal-footer {\n  padding: 20px 30px;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n}\n\n.view-customer-btn,\n.add-customer-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  border: none;\n  border-radius: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.view-customer-btn {\n  background: linear-gradient(135deg,  #d85200, #d85200);\n  color: white;\n}\n\n.add-customer-btn {\n  background: linear-gradient(135deg, #48bb78, #38a169);\n  color: white;\n}\n\n.view-customer-btn:hover,\n.add-customer-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n/* Form Styles */\n.add-flat-form,\n.customer-form {\n  padding: 30px;\n}\n\n.form-section {\n  margin-bottom: 30px;\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.section-icon {\n  color: #667eea;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-group label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  color: #4a5568;\n  font-size: 0.9rem;\n}\n\n.form-input,\n.form-select,\n.form-textarea {\n  padding: 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  background: white;\n}\n\n.form-input:focus,\n.form-select:focus,\n.form-textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-input.readonly {\n  background: #f8fafc;\n  color: #718096;\n  cursor: not-allowed;\n}\n\n.form-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  padding-top: 20px;\n  border-top: 1px solid #e2e8f0;\n  margin-top: 30px;\n}\n\n.cancel-btn {\n  padding: 12px 24px;\n  border: 2px solid #e2e8f0;\n  background: white;\n  color: #718096;\n  border-radius: 10px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.cancel-btn:hover {\n  border-color: #cbd5e0;\n  color: #4a5568;\n}\n\n.submit-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  background: linear-gradient(135deg,  #d85200 0%,  #d85200 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.submit-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px  #d8530014;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .flat-list-container {\n    padding: 15px;\n  }\n\n  .flat-list-header {\n    padding: 20px;\n  }\n\n  .header-content {\n    /* flex-direction: column; */\n    gap: 20px;\n    align-items: stretch;\n  }\n\n  .header-text h1 {\n    font-size: 2rem;\n    text-align: center;\n  }\n\n  .stats-container {\n    grid-template-columns: 1fr;\n  }\n\n  .floor-header {\n    flex-direction: column;\n    gap: 15px;\n    align-items: flex-start;\n  }\n\n  .floor-stats {\n    align-self: stretch;\n    justify-content: space-around;\n  }\n\n  .flats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .detail-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .modal-overlay {\n    padding: 10px;\n  }\n\n  .customer-modal {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .flat-list-header {\n    padding: 15px;\n  }\n\n  .header-text h1 {\n    font-size: 1.8rem;\n  }\n\n  .stat-card {\n    padding: 20px;\n  }\n\n  .floor-section {\n    padding: 15px;\n  }\n\n  .flat-card {\n    padding: 15px;\n  }\n\n  .modal-header {\n    padding: 20px;\n  }\n\n  .modal-content,\n  .add-flat-form,\n  .customer-form {\n    padding: 20px;\n  }\n\n  .form-actions {\n    flex-direction: column;\n  }\n\n  .cancel-btn,\n  .submit-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* Loading and Animation States */\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.floor-section {\n  animation: slideInUp 0.6s ease-out;\n}\n\n.flat-card {\n  animation: slideInUp 0.6s ease-out;\n  animation-delay: calc(var(--index, 0) * 0.1s);\n}\n\n/* Accessibility Improvements */\n.flat-button:focus,\n.delete-button:focus,\n.add-flat-btn:focus {\n  outline: 2px solid #667eea;\n  outline-offset: 2px;\n}\n\n.delete-button:focus {\n  opacity: 1;\n  transform: scale(1);\n}\n\n/* Print Styles */\n@media print {\n  .flat-list-container {\n    background: white;\n    padding: 0;\n  }\n\n  .delete-button,\n  .add-flat-btn {\n    display: none;\n  }\n\n  .flat-card {\n    break-inside: avoid;\n    box-shadow: none;\n    border: 1px solid #e2e8f0;\n  }\n\n  .modal-overlay {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
